
import { createSlice } from '@reduxjs/toolkit';

/** API may return alarms as [] or Laravel resource { data: [] } */
export function normalizeLockAlarmHistoryPayload(payload = {}) {
    const alarms = payload?.alarms;
    const list = Array.isArray(alarms)
        ? alarms
        : Array.isArray(alarms?.data)
            ? alarms.data
            : [];
    return { ...payload, alarms: list };
}

export const LockAlarmHistorySlice = createSlice({
    name: 'LockAlarmHistory',
    initialState: {
        loading: false,
        data: {

        },
        alarms:[],
        error: false,
    },
    reducers: {
        LOCK_ALARM_HISTORY_FETCH_START: (state) => {
            state.loading = true
        },
        LOCK_ALARM_HISTORY_FETCH_SUCCESS: (state, action) => {
            const payload = normalizeLockAlarmHistoryPayload(action.payload);
            state.loading = false
            state.error = false
            state.data = payload
            state.alarms = payload.alarms
        },
        LOCK_ALARM_HISTORY_LOAD_MORE_FETCH_SUCCESS: (state, action) => {
            const payload = normalizeLockAlarmHistoryPayload(action.payload);
            state.loading = false
            state.error = false
            state.data = payload
            state.alarms = [...state.alarms, ...payload.alarms]
        },
        LOCK_ALARM_HISTORY_EDIT_SUCCESS: (state, action) => {
            state.loading = false
            console.log(action.payload)
            const newArray = state.alarms.filter(todo => todo.id !==action.payload.id)
             state.alarms = [...newArray,action.payload]
        },
        
        LOCK_ALARM_HISTORY_FETCH_ERROR: (state) => {
            state.loading = false
            state.error = true
        }
    }
});

export const {LOCK_ALARM_HISTORY_EDIT_SUCCESS, LOCK_ALARM_HISTORY_LOAD_MORE_FETCH_SUCCESS,LOCK_ALARM_HISTORY_FETCH_START, LOCK_ALARM_HISTORY_FETCH_SUCCESS, LOCK_ALARM_HISTORY_FETCH_ERROR } = LockAlarmHistorySlice.actions;
export default LockAlarmHistorySlice.reducer;